import DelegateStructTreeSelector from "./DelegateStructTreeSelector";

import React, { useEffect, useRef, useState } from "react";

const DelegateStructTree = (
    {
        structs,
        isLoading,
        loadError,
        onRetry,
        selectedId,
        selectedName,
        onSelect,
    },
) => {
    const dropdownRef = useRef();
    const [isMenuActive, setIsMenuActive] = useState(false);

    function toggleMenuHandler() {
        setIsMenuActive((prev) => !prev);
    }

    function clickOutside(e) {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setIsMenuActive(false);
        }
    }

    function selectHandler(item) {
        onSelect(item);
        setIsMenuActive(false);
    }

    useEffect(() => {
        document.addEventListener("mousedown", clickOutside);
        return () => document.removeEventListener("mousedown", clickOutside);
    }, []);

    return (
        <div ref={dropdownRef} className={"delegate-struct-dropdown"}>
            <div
                onClick={toggleMenuHandler}
                className={"delegate-struct-dropdown__selected"}
            >
               <span> {selectedName || "Выберите подразделение"} </span>
                <span className={`delegate-struct-dropdown__arrow${isMenuActive ? "-up" : "-down"}`}></span>
            </div>
            <div className={`delegate-struct-dropdown__dropdown${isMenuActive ? "-active" : "-hidden"}`}>
                <DelegateStructTreeSelector
                    structs={structs}
                    isLoading={isLoading}
                    loadError={loadError}
                    onRetry={onRetry}
                    selectedId={selectedId}
                    onSelect={selectHandler}
                />
            </div>
        </div>
    );
};

export default DelegateStructTree;
